import { InteractionManager } from '@/SDK/InteractionManager';
import { logoutFromOkta } from './oktaAuth';

/**
 * Releases the workspace if currently open
 */
export const releaseWorkspaceIfOpen = async () => {
	const match = window.location.pathname.match(/^\/workspaceDetails\/(\d+)/);
	if (!match) return;
	try {
		await InteractionManager.getInstance().API.workspaceLockRelease({
			WorkspaceID: Number(match[1]),
		});
	} catch {
		// Best-effort — don't block logout if release fails
	}
};

/**
 * Handles the logout process including:
 * - Releasing any open workspace
 * - Logging out from Okta (if applicable)
 * - Clearing local session data
 */
export const authLogout = async (
	setInitialState?: (callback: (state: any) => any) => void,
) => {
	await releaseWorkspaceIfOpen();

	// Try to logout from Okta if user was authenticated via Okta
	try {
		await logoutFromOkta();
	} catch (error) {
		// Ignore errors, user might not be logged in via Okta
		console.log('Not logged in via Okta or logout failed:', error);
	}

	// Clear local session
	localStorage.removeItem('cargomind_current_user');
	localStorage.removeItem('cargomind_session');

	if (setInitialState) {
		setInitialState((s: any) => ({ ...s, currentUser: undefined }));
	}
};
